@if (attachForm) {
  <div [formGroup]="attachForm">
    @if (isDzbankUser) {
      <div class="flex flex-row align-items-center" [style]="{'width': '31rem'}">
        <label class="align-items-start justify-content-start w-10rem" for="commentId">
          {{ "investment.label.comment" | translate }}
        </label>
        <p-input-group class="w-21rem">
          @if (tradeTransactionType === SimpleHgType.Tagesgeld) {
            <textarea [tabindex]="11" pTextarea id="commentId" formControlName="comment" class="w-21rem h-5rem"
                      style="resize: none;"></textarea>
          } @else {
            <textarea [tabindex]="11" pTextarea id="commentId" formControlName="comment" class="w-21rem"
                      style="resize: none; height: 7.5rem"></textarea>

          }
        </p-input-group>
      </div>
    }
  </div>
}
